const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1']);

const isLocalDevelopment = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return LOCAL_HOSTNAMES.has(window.location.hostname);
};

const normalizeDomain = (domain: string): string => {
  return domain.replace(/^https?:\/\//i, '').replace(/\/$/, '');
};

const normalizeBasePath = (basePath?: string): string => {
  if (!basePath) {
    return '';
  }
  const trimmed = basePath.trim();
  if (trimmed === '' || trimmed === '/') {
    return '';
  }
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const getPreviewUrl = (siteId: string): string => {
  return isLocalDevelopment()
    ? `http://localhost:3002/${siteId}`
    : `https://preview.qwipe.jp/${siteId}`;
};

export const getDisplayUrl = (domain: string, basePath?: string): string => {
  const normalizedDomain = normalizeDomain(domain);
  const normalizedBasePath = normalizeBasePath(basePath);
  return `https://${normalizedDomain}${normalizedBasePath}`;
};

